import { render } from "./ContentCategoryForm.vue?vue&type=template&id=30ad677a&ts=true"
import script from "./ContentCategoryForm.vue?vue&type=script&lang=ts"
export * from "./ContentCategoryForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FK/Contents/Categories/ContentCategoryForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "30ad677a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('30ad677a', __exports__)) {
    api.reload('30ad677a', __exports__)
  }
  
  module.hot.accept("./ContentCategoryForm.vue?vue&type=template&id=30ad677a&ts=true", () => {
    api.rerender('30ad677a', render)
  })

}


export default __exports__